
import * as OM from '@/model';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import { BaseUserClient, DeferredPaymentClient, ProjectConfigClient, PurchaseClient, StripeClient } from '@/services/Services';
import { Prop } from "vue-property-decorator";
import { ModalServices } from '@/services/ModalServices';
import { LocalizationServices } from '@/services/LocalizationServices';
import store from '@/store';
import payWithDeferred from './payWithDeferred.vue';
import payWithSaldo from './payWithSaldo.vue';

@Options({
    components: {
        payWithDeferred,
        payWithSaldo
    }
})
export default class selectAndBuyOffers extends Vue {

    @Prop() offers: OM.ShopOffer[];

    isCordova: boolean = !!window.cordova;

    selectedOffer: OM.ShopOffer = null;
    shopCategory: OM.ShopCategory = null;
    metodoPagamento: OM.PaymentMethodDetails = null;
    needsFiscalCode: boolean = false;
    fiscalDataOk: boolean = false;

    formOk: boolean = false;

    tempMail: string = "";
    modificaMail: boolean = false;

    showMegaSpinner: boolean = false;
    paymentDone: boolean = false;
    
    shoppingCart: OM.ShoppingCart = new OM.ShoppingCart();

    stripePublicKey: string = "";

    paymentMethodsAvailable: OM.PaymentMethodDetails[] = [];

    created(){
        this.shoppingCart.customer = {
            identifier: store.state.user.identifier,
            name: store.state.user.personalData.completeName,
        }

        this.stripePublicKey = store.state.paymentConfig.stripePublicKey;
        ProjectConfigClient.getPaymentMethods()
        .then(x => {
            this.paymentMethodsAvailable = x;
        })
        this.tempMail = this.$store.state.user.contactData.email;
        this.fiscalDataOk = false;
        
        if(this.offers.length == 1){
            this.shoppingCart.offers = [
            {
                offer: {
                    identifier: this.offers[0].identifier,
                    name: this.offers[0].name
                },
                quantity: 1
            }
        ];
        }
    }

    get canFiscalDataOk(){
        if(!this.needsFiscalCode)
            return true;

        return !!this.$store.state.user.personalData.name &&
            !!this.$store.state.user.personalData.surname &&
            !!this.$store.state.user.fiscalData.sex &&
            !!this.$store.state.user.fiscalData.fiscalCode &&
            !this.$store.state.formErrors.codiceFiscale &&
            !!this.$store.state.user.fiscalData.dataNascita &&
            !!this.$store.state.user.fiscalData.luogoNascita &&
            this.canIndirizzoOk;
    }

    get canIndirizzoOk(){
        return !!this.$store.state.user.fiscalData.fiscalAddress.via &&
            !!this.$store.state.user.fiscalData.fiscalAddress.civico &&
            !!this.$store.state.user.fiscalData.fiscalAddress.citta &&
            !!this.$store.state.user.fiscalData.fiscalAddress.nazione &&
            !!this.$store.state.user.fiscalData.fiscalAddress.cap
    }

    fiscalDataNext(){
        Promise.all([
            BaseUserClient.updateFiscalData({
                identifier: this.$store.state.user.identifier, 
                data: this.$store.state.user.fiscalData
            })
        ])
        .then(x => {
            this.fiscalDataOk = true;
        })
    }



    setOffer(offer: OM.ShopOffer){
        if(this.offers.length == 1 && this.selectedOffer)
            return;
        if(this.paymentDone)
            return;

        this.shopCategory = null;
        this.selectedOffer = offer;
        this.shoppingCart.offers = [
            {
                offer: {
                    identifier: this.selectedOffer.identifier,
                    name: this.selectedOffer.name
                },
                quantity: 1
            }
        ];
    }

    getGrossAmount(item){
        if(this.metodoPagamento && this.metodoPagamento.priceMultiplier){
            return item.priceConfig.grossAmount * this.metodoPagamento.priceMultiplier;
        } else {
            return item.priceConfig.grossAmount;
        }
    } 
    
    get currencySymbol(){
        if(this.metodoPagamento && this.metodoPagamento.currencySymbol){
            return this.metodoPagamento.currencySymbol;
        } else {
            return store.state.paymentConfig.currencySymbol;
        }
    }

    get canStripe(){
        return true;
        // return this.shopCategory.metodiPagamento.some(x => x == OM.MetodoPagamento.Stripe)
    }
    
    get canBonifico(){
        return true;
        // return this.shopCategory.metodiPagamento.some(x => x == OM.MetodoPagamento.Bonifico)
    }

    intentCbStripe(){
        return StripeClient.createIntentForCart(this.shoppingCart, store.state.user.identifier)
    }

    sessionCbStripe(){
        return StripeClient.createSessionForCart(this.shoppingCart)
    }

    paymentConfigCbStripe(){
        return StripeClient.createClientPaymentConfigForCart(this.shoppingCart, store.state.user.identifier)
    }
    
    onPayCompleteCard(paymentId){
        // si passa di qui solo quando paga con il plugin di cordova
        // OffertaClient.completeBuyOfferta({
        //     stripeToken: paymentId,
        //     stripePublicKey: this.shopCategory.stripePublicKey,
        //     identifier: this.selectedOffer.identifier,
        //     appleIapId: null,
        //     upsellOfferIdentifier: null,
        //     activateOnCliente: null
        // })
        // .then(x => {
            this.$emit('cardpaid');
            this.paymentDone = true;
        // })
    }

    payDeferred(){
        this.showMegaSpinner = true;
        DeferredPaymentClient.createDeferredPayment({ 
            cart: this.shoppingCart,
            method: this.metodoPagamento.name
        })
        .then(x => {
            this.$emit('bonificopaid');
            this.paymentDone = true;
        })
        .finally(() => this.showMegaSpinner = false)
    }

    paySaldo(saldo){
        if(this.selectedOffer.priceConfig.grossAmount > saldo){
            ModalServices.alertModal(
                LocalizationServices.GetLocalizedValue("Errore", "Errore"),
                LocalizationServices.GetLocalizedValue("Saldo non sufficiente", "Saldo non sufficiente"),
            )
            return;
        }
        
        PurchaseClient.buyWithSaldo({
            cart: this.shoppingCart,
            method: this.metodoPagamento.name
        })
        .then(x => {
            this.$emit('saldopaid');
            this.paymentDone = true;
        })
        .finally(() => this.showMegaSpinner = false)

    }

};
